import React from 'react'

import adicionales from '../../images/SelectionHome/adicionales.png'
import capacitacion from '../../images/SelectionHome/capacitación.png'
import mantenimiento from '../../images/SelectionHome/mantenimiento.png'
import llave from '../../images/SelectionHome/llave_en_mano.png'
import { Link } from 'react-router-dom'

export default function SelectionHome() {
    return (
        <>
            <div className="bg-gris-1 home-selection">
                <Link to="/servicios/proyectomano" width="25%">
                    <img src={llave} width="100%" />
                </Link>
                <Link to="/servicios/mantenimiento" width="25%">
                    <img src={mantenimiento} width="100%" />
                </Link>
                <Link to="/servicios/capacitacion" width="25%">
                    <img src={capacitacion} width="100%" />
                </Link>
                <Link to="/servicios/serviciosadicionales" width="25%">
                    <img src={adicionales} width="100%" />
                </Link>
            </div>

        </>
    )
}
